import React from 'react';
import MDSpinner from 'react-md-spinner';
import { Trans } from '@lingui/macro';

type Props = {
    loadLong?: boolean,
    color?: string
}

const Loading = ({ loadLong, color = '#0086F1' }: Props) => (
    <div>
        <div className="sk-fading-circle">
            <MDSpinner singleColor={color} size={50} />
        </div>
        {loadLong ? (
            <p
                style={{ textAlign: 'center', marginTop: '-40px', fontSize: '16px' }}
            >
                <Trans id="common.takeTime" />
            </p>
        ) : null}
    </div>
);

export default Loading;
